import React, { useEffect, useState } from 'react';
import classes from './EditableLabel.module.scss';
import colors from '../../../../scss/colors';

export default function EditableLable(props) {
  const {
    value,
    changeHandler,
    fontSize = '14px',
    fontWeight = '325',
    fontColor = colors.NAVY_BLUE,
    type = 'number',
    disabled = false,
    width = '100%',
    enableKeyUp = false,
    sx,
    rootSx
  } = props;

  const [tempValue, setTempValue] = useState(value);

  const onBlurHandler = () => {
    if (tempValue !== value) {
      changeHandler(tempValue);
    }

    if (!tempValue) {
      setTempValue(0);
    }
  };

  const onFocusHandler = () => {
    if (Number(tempValue) === 0) {
      setTempValue('');
    }
  };

  const onKeyHandler = (e) => {
    if (enableKeyUp) {
      setTempValue(e.target.value);
      changeHandler(e.target.value);
    }
  };

  useEffect(() => {
    setTempValue(value);
  }, [value]);

  return (
    <div className={classes.fieldWrapper} style={rootSx}>
      <input
        disabled={disabled}
        className={`${classes.field} ${disabled ? classes.disabled : ''}`}
        style={({ fontSize, color: Number(tempValue) === 0 ? colors.LIGHT_GREY : fontColor, fontWeight, width }, sx)}
        type={type}
        value={tempValue}
        onChange={(e) => {
          setTempValue(e.target.value);
        }}
        onBlur={onBlurHandler}
        onFocus={onFocusHandler}
        onKeyUp={(e) => onKeyHandler(e)}
      />
    </div>
  );
}
